import React from "react"
import clsx from "clsx"
import RoomTypePriceBuilder from "../../RoomTypePriceBuilder/RoomTypePriceBuilder"
import DataTable from "../../DataTable/DataTable"



class RoomTypeBuilderPrices extends React.Component {

  constructor(props) {
    super(props)
    this.onAddRoomTypePrice = this.onAddRoomTypePrice.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onRemoveRoomTypePrice = this.onRemoveRoomTypePrice.bind(this);
  }


  render() {
    
    var self = this;
    var tabClasses = clsx({
      'active': this.props.active_tab == 'price',
      'tab-pane': true
    });
    

    if (this.props.is_new) {
      var room_type_price_index = 0;

      var room_type_prices = this.props.room_type_prices.map((room_type_price, idx) => {
        return(
          <div className="panel-body container" key={idx}>
            <RoomTypePriceBuilder
              {...room_type_price}
              key={room_type_price.id || self.generateId()}
              nested={true}
              tabs={false}  
              read_only={false} 
              onChange={self.onChange.bind(this, room_type_price.id)}
              onRemove={self.onRemoveRoomTypePrice}
              index={room_type_price_index++}
              onChangeAllDays={this.onChangeAllDays.bind(this, room_type_price.id)} 
              onChangeAllMinimumStays={this.onChangeAllMinimumStays.bind(this, room_type_price.id)}
              roomTypePrice={true}
              daily_rental={this.props.type_of_booking == 'daily' ? true : false}
              errors={this.props.errors}
              date_format={this.props.date_format}             
              />
          </div>
        )
      })
    }

    return (
      <div className={tabClasses}>
      {
        this.props.is_new
      ?
        <div className="row">
          <div className="col-md-12">
            <div className="panel panel-default" style={{marginBottom: 0}}>
              <div className="panel-heading flexed add-button-pannel">
                <div className="col-md-6" >
                  <h3 className="panel-title">
                    {I18n.t('group_contract_prices')} <span className="ss-help help" title={I18n.t('seasonal_prices_helper_text')}></span>
                  </h3>
                </div>
                <div className="col-md-6 content-right flexed">
                  <button className="btn btn-secondary float-right" onClick={this.onAddRoomTypePrice}>{I18n.t('add')}</button>

                </div>
              </div>
              {room_type_prices.length ? room_type_prices : <div className="no-records"><span className="none">{I18n.t('none')}</span></div>}
            </div>
          </div>
        </div>

      :
        <DataTable endpoint={this.props.room_type_prices_data_table_path}  
          date_format={this.props.date_format} 
          time_format={this.props.time_format} 
          no_data_text={I18n.t('none')} 
          currency_unit={I18n.t('number.currency.format.unit')}
          delimiter={I18n.t('number.currency.format.delimiter')}
          separator={I18n.t('number.currency.format.separator')}
        />
      }

    </div>



    )

  }

  generateId() {
    var text = "";
    var possible = "0123456789";

    for (var i = 0; i < 9; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    // console.log("text", text);
    return '-' + text;
  }



  onChange(room_type_price_id, room_type_price) {
    var room_type_prices = this.props.room_type_prices.slice(0);

    var idx = this.getRoomTypePriceIndexById(room_type_price_id);

    // room_type_price.season_id = this.props.season_id;

    room_type_prices[idx] = room_type_price;
    this.props.onChangeRoomTypePrices(room_type_prices);
  }

  onChangeAllDays(room_type_price_id, room_type_price) {
    
  }

  onChangeAllMinimumStays(room_type_price_id, room_type_price) {

  }

  onRemoveRoomTypePrice(e) {
    // console.log("onRemove", e.target.value);
    let room_type_price_id = e.target.value
    var room_type_prices = this.props.room_type_prices.slice(0);
    var idx = this.getRoomTypePriceIndexById(room_type_price_id);

    if (idx >= 0) {
      room_type_prices.splice(idx, 1);
      this.props.onChangeRoomTypePrices(room_type_prices);
    }
  }

  onAddRoomTypePrice(room_type) {
    // console.log("in onAddSeasonal");
    var room_type_prices = this.props.room_type_prices.slice(0);
    var room_type_price = {
      id: this.generateId(),
      start_date: this.props.current_date,
      // season: season,
      // room_type_id:  room_type ? season.id : '-0',
      // room_type: room_type || null,
      // room_type_id: this.props.room_type_id,
      // room_type_price: season.room_type_price,
      // room_type_price_id: season.room_type_price_id,
    };

    room_type_prices.unshift(room_type_price);
    this.props.onChangeRoomTypePrices(room_type_prices);
  }

  /**
  * Helper functions
  */

  getRoomTypePriceIndexById(id) {
    for (var i = 0, ilen = this.props.room_type_prices.length; i < ilen; i++) {
      if (this.props.room_type_prices[i].id == id) {
        return i;
      }
    }
  }




}

export default RoomTypeBuilderPrices